export const SUPPORT_WHATSAPP_URL = 'https://api.whatsapp.com/send/?phone=%2B5586994938467&text&type=phone_number&app_absent=0';

export function getSupportUrl() {
  return SUPPORT_WHATSAPP_URL;
}
